module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h1bb",
    attrs: {
      "id": "d7e350842"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/Morg_9781550924589_epub_c195_r1#d7e26186240",
      "id": "d14e753",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("kiwi")])])]), _vm._v(" "), _c('p', {
    staticClass: "h4a",
    attrs: {
      "id": "d7e351342"
    }
  }, [_c('span', [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CTINIDIA DELICIOSA")])])])]), _vm._v(" "), _c('p', {
    staticClass: "h1bb",
    attrs: {
      "id": "d7e351842"
    }
  }, [_c('span', [_vm._v("hardy kiwi")])]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    attrs: {
      "id": "d7e352342"
    }
  }, [_c('span', [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CTINIDIA ARGUTA")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e352942"
    }
  }, [_c('span', [_vm._v("I didn’t consider kiwi for the first edition because I just assumed they were tropical fruit in the manner of guavas. But then my friends Carolyn Dale and Tim Pilgrim, whose trellised kiwis provide summer shade in their beautiful Bellingham backyard, gave me a boxful in November. I learned they are picked green in early fall and need at least a month to fully ripen. Those kiwis were so much tastier than any I have had on a caterer’s tray that I realized I’ve been missing out.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e355842"
    }
  }, [_c('span', [_vm._v("My other revelation a few years back was a taste test of hardy kiwi at Cloud Mountain Farm. These are not the familiar fuzzy kind but grape-sized, smooth-skinned fruit that concentrates all of a large kiwi’s flavor into a much smaller space. As the name implies, the hardy vines are cold tolerant and also as exuberant as wisteria once they get going. However, they are a long-term project for gardeners, as they commonly take at least four years to begin bearing in quantity. Harvests are also vulnerable to blossom-killing early frosts in colder regions; the vines will endure, but you may not get fruit. Like raspberries, they bear on second-year wood, so pruners need to watch what they’re doing.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67c8f71e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Morg_9781550924589_epub_c20_r1.vue
// module id = 117
// module chunks = 0